const localizedVideos4i = function(){
	const mugImprintID =  "4d4a4d9b-4308-46ff-9492-149b82669dff";
	const videoTitle = 'Video for Mug Imprint Options';
	const videoAnalyticsTitle = 'Mug Imprints';
	const whyBuyVideoAnalyticsTitle = 'US-Why buy from 4imprint';

	return{
		MugImprintID: mugImprintID,
		VideoTitle: videoTitle,
		VideoAnalyticsTitle: videoAnalyticsTitle,
		WhyBuyVideoAnalyticsTitle: whyBuyVideoAnalyticsTitle
	};
};